<!--
 * @Description: 
 * @Author: pliybird
 * @Date: 2023-06-07 17:54:41
 * @LastEditTime: 2023-08-01 15:54:24
 * @LastEditors: 陈绍斌 1748362428@qq.com
 * @filePath: Do not edit
-->
<template>
  <div class="container">
    <div class="row product-summarize">
        <div class="summarize-text col slider-bg-image"
          :style="{ 'background-image': `url(${require('@/assets/images/ProductService/common/summarize-background.png')})` }">
          <div class="text-title">{{ this.$t('product.VyungCPQ.product_overview.title') }}</div>
          <div v-if="summarizeText !== ''">
              <div class="text-content">{{ summarizeText }}</div>
          </div>
          <div v-else>
              <div class="text-content">{{ summarizeTextList.text01 }}</div>
              <div class="text-content">{{ summarizeTextList.text02 }}</div>
          </div>
        </div>
        <div class="video-box col" :class="{'invisible':videoData[0].src == ''}" v-show="$i18n.locale === 'zh_CN'"> 
            <div class="video-wrap w-100">
                <Video :video-data="videoData" :videoStyle="2" column="col-12"/>
            </div>
        </div>
    </div>
    
    
  </div>
</template>

<script>
  import Video from '../../../components/elements/video/Video'

    export default {
        name: 'ProductOverview',
        components: { Video },
        props:{
          'summarizeText':{
            type:String,
            default: '',
          },
          'summarizeTextList':{
            type:Object,
            default: ()=>{},
          },
          'videoData':{
            type:Array,
            default:[],
          },
        },
        data() {
            return {

            }
        },
        methods:{
            // 播放视频
            playVideo(){
              let videoElement = this.$refs.videoPlayer;
              videoElement.play();
            }
        }
    }
</script>